// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2KpZp","footer":"ReportModalFilter_footer__PxdXu"};